const colors = {
    primary: "#06b4b8",
    error: "#e94949",
    secondary: "#086eb9",
    success: "#32b081",
    warning: "#FF9632",
    light: "#FFFFFF"
};

export default colors;
